import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';
import Radio from 'backbone.radio';

import { validateForm } from '@/util/ParsleyUtils';
import makeFormReadOnly from '@/util/makeFormReadOnly';
import showSuccessMessage from '@/util/ShowSuccessMessage';
import showErrorMessage from '@/util/showErrorMessage';
import OrderStatuses from '@/enums/OrderStatuses';

import HandleOrderSubmission from '../../services/HandleOrderSubmission';
import ValidateOrderModule from '../../services/ValidateOrderModule';

import tmplOrderDecisionView from './OrderDecisionView.hbs';

const OrderDecisionView = View.extend({
  template: tmplOrderDecisionView,

  className: 'order-decision-view',

  ui: {
    crsDecisionStatus: '.crs-decision',
    saveBtn: '.save-button',
    submitBtn: '.submit-button',
    decisionStatusError: '#decisionStatusError'
  },

  events: {
    'click input[type="radio"]': 'onChangeDecision'
  },

  templateContext() {
    const decisionData = this.model.get('decisionData');
    return {
      returnChecked: decisionData.crsDecisionStatus === OrderStatuses.RETURNED,
      approveChecked: decisionData.crsDecisionStatus === OrderStatuses.APPROVED_APPROVED,
      isInternalUser: !EXTERNAL
    };
  },

  onChangeDecision() {
    if ($("input:radio[name='decisionStatus']:checked").val() === OrderStatuses.RETURNED) {
      $('#explanationTextArea').prop('required', true);
    } else {
      $('#explanationTextArea').prop('required', false);
    }
  },

  onRender() {
    if (!this.model.get('editable')) {
      makeFormReadOnly(this.$el);
    }
  },

  showSaveSuccess() {
    showSuccessMessage({
      code: 'saveSuccess',
      title: 'Save Success',
      message: 'This order has been saved successfully.',
      hideAfter: 5
    });
  },

  showSaveError() {
    showErrorMessage({
      errorCode: 'saveError',
      errorTitle: 'Save Error',
      errorMessage:
        'An error occurred while saving this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showSubmitSuccess() {
    showSuccessMessage({
      code: 'submitSuccess',
      title: 'Submit Success',
      message: 'This order has been submitted successfully.',
      hideAfter: 5
    });
  },

  showSubmitError(orderId) {
    showErrorMessage({
      errorCode: 'submitError',
      errorTitle: 'Submit Error',
      errorMessage: `There was an error submitting order ${orderId}. Please try again or contact an administrator if the issue persists.`,
      hideAfter: 5
    });
  },

  async validate() {
    try {
      await validateForm(this.ui.crsDecisionStatus);
      this.trigger('no:errors');
      return true;
    } catch {
      this.trigger('has:errors');
      return false;
    }
  },

  async onSave() {
    // external users should not be able to save
    if (EXTERNAL) return;

    const decisionFormData = Syphon.serialize(this.ui.crsDecisionStatus);

    try {
      await HandleOrderSubmission(
        this.model.get('orderDetails').orderId,
        decisionFormData.decisionStatus,
        decisionFormData.explanation,
        'save'
      );

      this.showSaveSuccess();
    } catch (err) {
      this.showSaveError();
      throw new Error(err);
    }
  },

  async onSubmit() {
    // external users should not be able to submit
    if (EXTERNAL) return;

    const decisionFormData = Syphon.serialize(this.ui.crsDecisionStatus);

    const isValid = await ValidateOrderModule.validate({
      calledOnReturn: decisionFormData.decisionStatus === OrderStatuses.RETURNED
    });

    if (!isValid) return;

    try {
      await HandleOrderSubmission(
        this.model.get('orderDetails').orderId,
        decisionFormData.decisionStatus,
        decisionFormData.explanation,
        'submit'
      );

      this.showSubmitSuccess();
      await Radio.channel('navigate').request('show:int:dashboard');
    } catch (err) {
      this.showSubmitError(this.model.get('orderDetails.orderId'));
    }
  }
});

export default OrderDecisionView;
